export default [
  // PRODUCT
  {
    path: '/master/product/list',
    name: 'master-product-list',
    component: () => import('@/views/master-data/product/product-list/ProductList.vue'),
    meta: {
      pageTitle: 'Produk',
      breadcrumb: [
        {
          text: 'Produk',
          active: true,
        },
      ],
      resource: 'master-product-list',
      action: 'read',
    },
  },
  {
    path: '/master/product/add',
    name: 'master-product-add',
    component: () => import('@/views/master-data/product/product-add/ProductAdd.vue'),
    meta: {
      pageTitle: 'Tambah Produk',
      breadcrumb: [
        {
          text: 'Produk',
        },
        {
          text: 'Tambah',
          active: true,
        },
      ],
      resource: 'master-product-list',
      action: 'read',
    },
  },
  {
    path: '/master/product/edit/:id',
    name: 'master-product-edit',
    component: () => import('@/views/master-data/product/product-edit/ProductEdit.vue'),
    meta: {
      pageTitle: 'Edit Produk',
      breadcrumb: [
        {
          text: 'Produk',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      resource: 'master-product-list',
      action: 'read',
    },
  },

  // CATEGORY
  {
    path: '/master-data/category/list',
    name: 'master-category-list',
    component: () => import('@/views/master-data/category/category-list/CategoryList.vue'),
    meta: {
      pageTitle: 'Kategori',
      breadcrumb: [
        {
          text: 'Kategori',
          active: true,
        },
      ],
      resource: 'master-category-list',
      action: 'read',
    },
  },
  {
    path: '/master-data/category/add',
    name: 'master-category-add',
    component: () => import('@/views/master-data/category/category-add/CategoryAdd.vue'),
    meta: {
      pageTitle: 'Tambah Kategori',
      breadcrumb: [
        {
          text: 'Produk',
        },
        {
          text: 'Tambah',
          active: true,
        },
      ],
      resource: 'master-category-list',
      action: 'read',
    },
  },
  {
    path: '/master-data/category/edit/:id',
    name: 'master-category-edit',
    component: () => import('@/views/master-data/category/category-edit/CategoryEdit.vue'),
    meta: {
      pageTitle: 'Edit Kategori',
      breadcrumb: [
        {
          text: 'Kategori',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      resource: 'master-category-list',
      action: 'read',
    },
  },

  // SUPPLIER
  {
    path: '/master-data/supplier/list',
    name: 'master-supplier-list',
    component: () => import('@/views/master-data/supplier/supplier-list/SupplierList.vue'),
    meta: {
      pageTitle: 'Supplier',
      breadcrumb: [
        {
          text: 'Supplier',
          active: true,
        },
      ],
    },
    resource: 'master-supplier-list',
    action: 'read',
  },
  {
    path: '/master-data/supplier/add',
    name: 'master-supplier-add',
    component: () => import('@/views/master-data/supplier/supplier-add/SupplierAdd.vue'),
    meta: {
      pageTitle: 'Tambah Supplier',
      breadcrumb: [
        {
          text: 'Supplier',
        },
        {
          text: 'Tambah',
          active: true,
        },
      ],
      resource: 'master-supplier-list',
      action: 'read',
    },
  },
  {
    path: '/master-data/supplier/edit/:id',
    name: 'master-supplier-edit',
    component: () => import('@/views/master-data/supplier/supplier-edit/SupplierEdit.vue'),
    meta: {
      pageTitle: 'Edit Supplier',
      breadcrumb: [
        {
          text: 'Supplier',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      resource: 'master-supplier-list',
      action: 'read',
    },
  },
  // CUSTOMER
  {
    path: '/master-data/customer/list',
    name: 'master-customer-list',
    component: () => import('@/views/master-data/customer/customer-list/CustomerList.vue'),
    meta: {
      pageTitle: 'Pelanggan',
      breadcrumb: [
        {
          text: 'Pelanggan ',
          active: true,
        },
      ],
      resource: 'master-customer-list',
      action: 'read',
    },
  },
  {
    path: '/master-data/customer/bill',
    name: 'master-customer-bill',
    component: () => import('@/views/master-data/customer/customer-list/CustomerBill.vue'),
    meta: {
      pageTitle: 'Pelanggan',
      breadcrumb: [
        {
          text: 'Pelanggan ',
          to: { name: 'master-customer-list' },
        },
        {
          text: 'Tagihan Pelanggan',
          to: { name: 'master-customer-bill' },
          active: true,
        },
      ],
      resource: 'master-customer-list',
      action: 'read',
    },
  },
  {
    path: '/master-data/customer/deposit',
    name: 'master-customer-deposit',
    component: () => import('@/views/master-data/customer/customer-add/CustomerDeposit.vue'),
    meta: {
      pageTitle: 'Pelanggan',
      breadcrumb: [
        {
          text: 'Pelanggan ',
          to: { name: 'master-customer-list' },
        },
        {
          text: 'Deposit Pelanggan',
          to: { name: 'master-customer-deposit' },
          active: true,
        },
      ],
      resource: 'master-customer-list',
      action: 'read',
    },
  },
  {
    path: '/master-data/customer/deposit/print/:id',
    name: 'print-customer-deposit',
    component: () => import('@/views/feature/PrintDepositHistory.vue'),
    meta: {
      resource: 'master-customer-list',
      action: 'read',
    },
  },
  {
    path: '/master-data/customer/add',
    name: 'master-customer-add',
    component: () => import('@/views/master-data/customer/customer-add/CustomerAdd.vue'),
    meta: {
      pageTitle: 'Pelanggan',
      breadcrumb: [
        {
          text: 'Pelanggan ',
        },
        {
          text: 'Tambah',
          active: true,
        },
      ],
      resource: 'master-customer-list',
      action: 'read',
    },
  },
  {
    path: '/master-data/customer/edit/:id',
    name: 'master-customer-edit',
    component: () => import('@/views/master-data/customer/customer-edit/CustomerEdit.vue'),
    meta: {
      pageTitle: 'Edit Pelanggan',
      breadcrumb: [
        {
          text: 'Pelanggan',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      resource: 'master-customer-list',
      action: 'read',
    },
  },

  // UNIT
  {
    path: '/master-data/unit/list',
    name: 'master-unit-list',
    component: () => import('@/views/master-data/unit/unit-list/UnitList.vue'),
    meta: {
      pageTitle: 'Jenis Satuan',
      breadcrumb: [
        {
          text: 'Jenis Satuan',
          active: true,
        },
      ],
      resource: 'master-unit-list',
      action: 'read',
    },
  },
  {
    path: '/master-data/unit/add',
    name: 'master-unit-add',
    component: () => import('@/views/master-data/unit/unit-add/UnitAdd.vue'),
    meta: {
      pageTitle: 'Tambah Satuan',
      breadcrumb: [
        {
          text: 'Jenis Satuan',
        },
        {
          text: 'Tambah',
          active: true,
        },
      ],
      resource: 'master-unit-list',
      action: 'read',
    },
  },
  {
    path: '/master-data/unit/edit/:id',
    name: 'master-unit-edit',
    component: () => import('@/views/master-data/unit/unit-edit/UnitEdit.vue'),
    meta: {
      pageTitle: 'Edit Satuan',
      breadcrumb: [
        {
          text: 'Jenis Satuan',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      resource: 'master-unit-list',
      action: 'read',
    },
  },
  // SHIPPING
  {
    path: '/master-data/shipping/list',
    name: 'master-shipping-list',
    component: () => import('@/views/master-data/shipping/shipping-list/ShippingList.vue'),
    meta: {
      pageTitle: 'Ekspedisi',
      breadcrumb: [
        {
          text: 'Ekspedisi',
          active: true,
        },
      ],
      resource: 'master-shipping-list',
      action: 'read',
    },
  },
  {
    path: '/master-data/shipping/add',
    name: 'master-shipping-add',
    component: () => import('@/views/master-data/shipping/shipping-add/ShippingAdd.vue'),
    meta: {
      pageTitle: 'Tambah Ekspedisi',
      breadcrumb: [
        {
          text: 'Ekspedisi',
          to: { name: 'master-shipping-list' },
        },
        {
          text: 'Tambah',
          active: true,
        },
      ],
      resource: 'master-shipping-list',
      action: 'read',
    },
  },
  {
    path: '/master-data/shipping/edit/:id',
    name: 'master-shipping-edit',
    component: () => import('@/views/master-data/shipping/shipping-edit/ShippingEdit.vue'),
    meta: {
      pageTitle: 'Edit Ekspedisi',
      breadcrumb: [
        {
          text: 'Ekspedisi',
          to: { name: 'master-shipping-list' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      resource: 'master-shipping-list',
      action: 'read',
    },
  },
]
